<!-- This component will be loaded in layout.blade.php every login page for Admin -->
<template>
		<li class="dropdown currencies-menu">
      <a href="#" class="dropdown-toggle" role="menu" data-toggle="dropdown">
        <i class="fa fa-money">&nbsp;<span class="caret"></span></i>
      </a>
      <ul class="dropdown-menu" style="width:70px; min-width:unset;">
        <!-- <li class="note" v-text="description"></li> -->
        <li class="body" v-for="currency in currencies" :key="currency.hashid" :style="[ currency.id == mycurrency ? {'border': '2px solid #ade2a8', 'background-color': '#bcf1b7'} : {} ]">

          <!-- <a href="#" @click="updateCurrency(currency.id)">{{ currency.code }}  -->
          <a :href="baseroute + '/updateCurrency/' + currency.hashid"> {{ currency.code }}
            </a> 
          <!-- <a href="#">{{ currency.code }} <span class="fa fa-check" style="margin-left:5px" v-text="mycurrency" v-if="currency.code == mycurrency"></span></a>  -->

        </li>
      </ul>
    </li>
</template>

<script>
    var axios = require('axios');

    export default {
    	data() {
    		return {
          currencies: [],     // define empty variable
    			product: 'boots',
    			stock_count: 20
    		}
    	},
      created() {     // Run this after vue object created
          this.fetchCurrencies(); // use the fetchCurrencies() function 
      },
      props: [
        'mycurrency', 
        'baseroute'
      ],
      methods: {
          fetchCurrencies() {     // Define the fetchCurrencies() function 
            // fetch('api/getCurrencies')
            // fetch('getCurrencies')
            //     .then(res => res.json())
            //     .then(res => {
            //         this.currencies = res.data;     // put this data into currencies varaible
            //     })
            console.log("this.baseroute = " + this.baseroute);
            axios.get(this.baseroute + '/getCurrencies')
                .then(response => {
                    console.log(response);
                    this.currencies = response.data;     // put this data into currencies varaible
                    console.log("currencies = ");
                    console.log(this.currencies);
                })
                // .then(function (response) {
                //     console.log(response);
                //     console.log(response.data);
                //     this.currencies = response.data;     // put this data into currencies varaible
                // })
                .catch(function (error) {
                    // Wu oh! Something went wrong
                    console.log("Failed fecthing currency");
                    console.log(error.message);
                });
          },
          updateCurrency(id) {
            console.log("updateCurrency, id = " + id);
            // fetch(`api/updateCurrency/${id}`, {   // Pay attention, this is different symbol
            fetch(`updateCurrency/${id}`, {   // Pay attention, this is different symbol
              method: 'get',
            })
            .then(res => res.json())
            .then(data => {
              alert('Currency Updated');
              // this.fetchCurrencies();
            })
          }
      },
      mounted() {     // Run this after vue object mounted on html screen 
          console.log('CurrenciesDropDown.vue Component mounted.')
      }
    }
</script>

<style>
.greeting {
  color: red;
  font-weight: bold;
}
</style>